import { Link } from "react-router-dom";
import { ExternalLink, Printer, Download, Loader2 } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../App";
import { Button } from "./ui/button";

export const downloadDocketCsv = async (d) => {
  try {
    const r = await axios.get(`${API}/solon/dockets/${d.id}/export`, { responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = `ekthema_${d.hearing_date}_${(d.pinakio_name || d.docket_label || "").split(" - ")[0]}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  } catch { toast.error("Σφάλμα εξαγωγής"); }
};

/** Πίνακας εκθέματος SOLON (γραμμές Α/Α, ΓΑΚ, ΕΑΚ…) — κοινός για τη σελίδα Εκθεμάτων και το dialog των Πινακίων. */
export const DocketTable = ({ detail, testId }) => {
  if (!detail) return <div className="text-slate-500 text-sm"><Loader2 className="w-4 h-4 animate-spin inline mr-1" />Φόρτωση…</div>;
  const lines = [...(detail.lines || [])].sort((a, b) => (a.aa_num || 0) - (b.aa_num || 0));
  return (
    <>
      <div className="flex flex-wrap items-center justify-between gap-2 mb-2 text-xs text-slate-500">
        <span data-testid={`${testId}-meta`}>Αντλήθηκε: {new Date(detail.fetched_at).toLocaleString("el-GR")} · Πρωτοείσακτες {detail.first_count} · Αναβλητικές {detail.deferred_count}{detail.time ? ` · ${detail.time}` : ""}{detail.room ? ` · ${detail.room}` : ""}</span>
        <div className="flex gap-1 print:hidden">
          <Button size="sm" variant="outline" onClick={() => downloadDocketCsv(detail)} data-testid={`${testId}-csv`}><Download className="w-4 h-4 mr-1" />CSV</Button>
          <Button size="sm" variant="outline" onClick={() => window.print()} data-testid={`${testId}-print`}><Printer className="w-4 h-4 mr-1" />Εκτύπωση</Button>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-xs" data-testid={`${testId}-table`}>
          <thead className="bg-slate-50 text-slate-600"><tr><th className="p-2 text-left">Α/Α</th><th className="p-2 text-left">ΓΑΚ/Έτος</th><th className="p-2 text-left">ΕΑΚ/Έτος</th><th className="p-2 text-left">Εισαγωγή</th><th className="p-2 text-left">Αντικείμενο</th><th className="p-2 text-left">Α' Ενάγων</th><th className="p-2 text-left">Δικηγόρος</th><th className="p-2 text-left">Αντιμωλία/Ερήμην</th><th className="p-2 text-left">Σύστημα</th></tr></thead>
          <tbody>
            {lines.map((ln, i) => (
              <tr key={i} className={`border-t ${ln.case_id ? "bg-emerald-50/40" : ""}`}>
                <td className="p-2">{ln.aa}</td><td className="p-2 font-mono">{ln.gak_full}</td><td className="p-2 font-mono">{ln.eak_full}</td>
                <td className="p-2">{ln.intro_type}</td><td className="p-2">{ln.subject}</td><td className="p-2">{ln.plaintiff_initial}</td>
                <td className="p-2">{ln.lawyer}</td><td className="p-2">{ln.presence}</td>
                <td className="p-2">{ln.case_id ? <Link to={`/cases/${ln.case_id}`} className="text-blue-700 hover:underline inline-flex items-center gap-1" data-testid={`docket-case-link-${ln.case_id}`}>Υπόθεση <ExternalLink className="w-3 h-3" /></Link> : <span className="text-slate-300">—</span>}</td>
              </tr>
            ))}
            {lines.length === 0 && <tr><td colSpan={9} className="p-4 text-center text-slate-400">Το έκθεμα δεν περιέχει υποθέσεις</td></tr>}
          </tbody>
        </table>
      </div>
    </>
  );
};
